export const otpList = {
  otpList: "OTP List",
  phoneNumber: "PHONE NUMBER",
  refcode: "REF. CODE",
  otp: "SMS OTP",
  isVerified: "ISVERIFIED",
  createdAt: "CREATED AT",
  showing: "Showing",
  to: "to",
  results: "results",
  of: "of",
};
